import { fromUnixTime, format } from 'date-fns'

export default function (value, dateFormat = 'yyyy mm', unixTimeFlag = true) {
  if (!value) {
    return '-'
  }
  if (unixTimeFlag) {
    value = fromUnixTime(value)
  }
  return format(value, dateFormat)
}
